import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Input, Tooltip } from 'antd';
import { encode as base64_encode } from 'base-64';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import history from '../../../../../commons/history';
import ListView from '../../../Utils/ListView';
import themeSettings from '../../../Utils/themeSettings.json';
import translation from '../../../Utils/translation';
import { constant } from '../../../Utils/constants';
import { getUserProfile } from '../../../../../selectors/layout';
import { getTranslationCache } from '../../../../../selectors/language';
import { deleteById, getUsersList, getInspectionScheduleList } from '../../../Utils/FormCalls';
import { StyledComponent } from '../../../CSS/style';
import localStorage from '../../../../../utils/localStorage';
import Highlighter from 'react-highlight-words';
import { API_SERVICEREQ } from '../../../../../commons/api';

class SRList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      userProfile: props && props.userProfile ? props.userProfile : {},
      userList: [],
      config: {
        viewTypes: ['add', 'card', 'table'],
        defaultViewType: 'table',

        filterType: 'ByAttributeValue',
        attributeList: ['Name'],

        firstTitle: 'Name',
        secondTitle: 'CreatedBy',
        thirdTitle: 'CreatedDate',

        actions: ['edit', 'delete'],
        edit: {
          byAttribute: 'Id',
          redirectURL: '/rubus/AMM/ELogScheduleDetails'
        },
        deletee: {
          byAttribute: 'Id'
        }
      }
    };
  }

  componentDidMount = async () => {
    this._getDataSource();
  };

  componentDidUpdate(prevprops) {
    if (this.props.userProfile !== prevprops.userProfile) {
      this.setState({ userProfile: this.props.userProfile });
      this._getDataSource();
    }
  }

  _editRecord = async (record) => {
    let { config } = this.state;
    history.push({ pathname: `${config.edit.redirectURL}${base64_encode(record.Id)}` });
  };

  _getUserList = async () => {
    let userList = await getUsersList();
    this.setState({ userList });
  };

  _getDataSource = async () => {
    let dataSource = await getInspectionScheduleList();
    this.setState({
      dataSource
    });
  };

  edit = async (record) => {
    let { config } = this.state;
    history.push({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  _deleteById = async (id) => {
    const siteId = localStorage.get('currentSite');
    let payload = {
      url: `${API_SERVICEREQ.DELETE}?Id=${id}&SiteId=${siteId}`,
      method: 'POST'
    };
    await deleteById(payload);
    let dataSource = await getInspectionScheduleList();
    this.setState({
      dataSource
    });
  };
  getColumnSearchProps = (dataIndex, columnName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation(this.props.translationCache, `Search ${columnName}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
          //maxLength={30}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(this.props.translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          {translation(this.props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, fontSize: '130%' }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };
  handleReset = (clearFilters, confirm) => {
    clearFilters();
    this.handleSearch([], confirm);
  };

  render() {
    let { dataSource, userList } = this.state;
    let { translationCache } = this.props;

    let columns = [
      {
        title: translation(translationCache, 'Name'),
        dataIndex: 'Name',
        key: 'Name',
        ...this.getColumnSearchProps('Name', 'Name'),
        filter: true
      },
      {
        title: translation(translationCache, constant.description),
        dataIndex: 'Description',
        key: 'Description',
        ...this.getColumnSearchProps('Description', 'Description')
      },
      {
        title: translation(translationCache, constant.site),
        dataIndex: 'SiteId',
        key: 'SiteId',
        filter: true,
        render: (text) => translation(translationCache, text)
      },
      {
        title: translation(translationCache, constant.workType),
        dataIndex: 'WorkType',
        key: 'WorkType',
        filter: true
      },
      {
        title: translation(translationCache, constant.action),
        width: '600',
        render: (text, record) => (
          <>
            <Button
              disabled={record.Status === 'Inactive' ? true : false}
              style={{ marginRight: '5px' }}
              className="ant-btn"
              onClick={() => this.edit(record)}
              size="middle"
            >
              <Tooltip title={translation(translationCache, 'Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
            {/* <Popconfirm
              title={translation(
                translationCache,
                'Are you sure that you want to delete the ElogBook Schedule'
              )}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => this._deleteById(record.Id)}
              okText={translation(translationCache, constant.yes)}
              cancelText={translation(translationCache, constant.yes)}
            >
              <Button className="ant-btn" size="middle">
                <span style={{ color: '#ff4d4f' }}>
                  {' '}
                  <Tooltip title={translation(translationCache, 'Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </span>
              </Button>
            </Popconfirm> */}
          </>
        )
      }
    ];
    let config = {
      title: translation(translationCache, 'ELogbook Schedule'),

      viewTypes: ['add', 'card', 'table'],
      defaultViewType: 'table',

      filterType: 'ByAttributeValue',
      attributeList: ['Name'],

      firstTitle: 'Name',
      secondTitle: 'CreatedBy',
      thirdTitle: 'CreatedDate',

      actions: ['edit'],
      edit: {
        byAttribute: 'Id',
        redirectURL: '/rubus/AMM/ELogScheduleDetails'
      },
      deletee: {
        byAttribute: 'Id'
      }
    };
    return (
      <StyledComponent theme={themeSettings} style={{ minHeight: window.innerHeight - 143 }}>
        <ListView
          columns={columns}
          dataSource={dataSource}
          userList={userList}
          config={config}
          delete={this._deleteById}
        />
      </StyledComponent>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  userProfile: getUserProfile(),
  translationCache: getTranslationCache()
});
export default connect(mapStateToProps)(SRList);
